import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import SuccessComponent from "../../components/shared/SuccessComponent/SuccessComponent";

interface ISearchParams {
  title: string;
  description: string;
  linkPath: string | null;
  linkText: string | null;
}

const SuccessPage = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useState<ISearchParams>({
    title: "",
    description: "",
    linkPath: null,
    linkText: null,
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const title = searchParams.get("title");
    const description = searchParams.get("description");
    const linkPath = searchParams.get("linkPath");
    const linkText = searchParams.get("linkText");
    if (title && description) {
      setSearchParams({
        title,
        description,
        linkPath: linkPath || null,
        linkText: linkText || null,
      });
    }
  }, []);

  return (
    <>
      <SuccessComponent
        title={searchParams.title}
        description={searchParams.description}
        linkText={searchParams.linkText}
        linkPath={searchParams.linkPath}
      />
    </>
  );
};

export default SuccessPage;
